module.exports = __webpack_public_path__ + "img/master-title.d4c2f863.png";